/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Page_Error_TitleInputs */

const fr_page_error_title = /** @type {(inputs: Page_Error_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossible d’ouvrir cette page`)
};

const en_page_error_title = /** @type {(inputs: Page_Error_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This page couldn’t be opened`)
};

/**
* | output |
* | --- |
* | "This page couldn’t be opened" |
*
* @param {Page_Error_TitleInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const page_error_title = /** @type {((inputs?: Page_Error_TitleInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Page_Error_TitleInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_page_error_title(inputs)
	return fr_page_error_title(inputs)
});